import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';

import { Icon } from 'components/tokens/Icon';
import { chevronRight } from 'icons/default';
import { Colors } from 'enums/Colors';

import styles from './Breadcrumbs.module.scss';

interface IBreadcrumbsItem {
  text: string;
  href: string;
}

interface IBreadcrumbs {
  staticBreadcrumbs?: Array<IBreadcrumbsItem>;
  asLinkStyle?: boolean;
}

export const Breadcrumbs: React.VFC<IBreadcrumbs> = ({ asLinkStyle, staticBreadcrumbs }) => {
  const router = useRouter();
  const [breadcrumbs, setBreadcrumbItems] = useState<Array<IBreadcrumbsItem>>(
    staticBreadcrumbs || []
  );

  useEffect(() => {
    if (router && !staticBreadcrumbs) {
      const linkPath = router.asPath.split('/');
      linkPath.shift();

      const pathArray = linkPath.map((path, i) => ({
        text: path,
        href: `/${linkPath.slice(0, i + 1).join('/')}`,
      }));

      setBreadcrumbItems(pathArray);
    }
  }, [router, staticBreadcrumbs]);

  if (!breadcrumbs.length) {
    return null;
  }

  return (
    <nav>
      <ol className={styles.list}>
        {breadcrumbs.map(({ text, href }, index) => {
          const isLastItem = index === breadcrumbs.length - 1;
          return (
            <li key={text}>
              <div className={styles['link-wrapper']}>
                <Link href={href} passHref>
                  <a
                    className={`${styles.link} ${asLinkStyle ? styles['link--as-link-style'] : ''}`}
                  >
                    {text}
                  </a>
                </Link>
                {!isLastItem ? (
                  <Icon color={Colors.DarkBlue100} icon={chevronRight} size={7} />
                ) : null}
              </div>
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
